import { Star } from "lucide-react";
import type { RatingSummary as RatingSummaryData } from "../../domain/ratings";

export function RatingSummary({ summary, expanded = false }: { summary: RatingSummaryData; expanded?: boolean }) {
  if (summary.average === null) {
    return <span className={expanded ? "rating-summary is-expanded is-new" : "rating-summary is-new"}>Nueva · aún sin valoraciones</span>;
  }
  return (
    <div className={expanded ? "rating-summary is-expanded" : "rating-summary"} aria-label={`${summary.average} de 5 estrellas, ${summary.count} valoraciones`}>
      <span className="rating-average"><Star fill="currentColor" aria-hidden="true" /><strong>{summary.average.toFixed(1)}</strong></span>
      <span>{summary.count} {summary.count === 1 ? "valoración" : "valoraciones"}</span>
      {expanded && summary.topTags.length > 0 && (
        <div className="rating-public-tags" aria-label="Lo más mencionado">
          {summary.topTags.map((tag) => <span key={tag.id}>{tag.label}</span>)}
        </div>
      )}
    </div>
  );
}
